// File: src/components/landing/FaqSection.jsx
import React, { useState } from "react";
import { IoChevronDown } from "react-icons/io5";

const faqs = [
  {
    question: "Why is Tribe invite-only?",
    answer: "Because our members make Tribe what it is. We cap membership and thoughtfully curate who joins, so every gathering feels welcoming, interesting, and worth showing up for.",
  },
  {
    question: "What kinds of gatherings do you host?",
    answer: "We host social plans like bar crawls, picnics, yoga, museum hangs, thrifting, wine nights, movie nights, foodie adventures, and more.",
  },
  {
    question: "Is Tribe free?",
    answer: "Yes. Tribe is completely free.",
  },
  {
    question: "What do I get as a member?",
    answer: "Membership includes 3 hosted gatherings each month, access to Tribe’s platform features, and invitations to exclusive festivals and member-only experiences.",
  },
  {
    question: "How is Tribe different from an event app?",
    answer: "Tribe is built for making friends, not just finding things to do. The plans are smaller, hosted, and designed to help people actually meet each other.",
  },
  {
    question: "How big are gatherings?",
    answer: "Most gatherings are small, usually around 8–12 people. That keeps the experience social, easy to join, and built for real conversation.",
  },
  {
    question: "What does the host do?",
    answer: "The host helps people find the group, welcomes everyone in, explains the plan, and facilitates the activity so the gathering feels organized and easy to join.",
  },
  {
    question: "Can I come alone or bring a friend?",
    answer: "Yes. You can come alone or bring a friend, but your friend needs to sign up and reserve their own spot for the gathering too.",
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="faqSection" style={styles.faqSection}>
      <style>
        {`
          @media (max-width: 450px) {
            .faqSection {
              max-width: none !important;
              margin: 0 !important;
              padding: 0 !important;
              display: block !important;
              grid-template-columns: none !important;
              gap: 0 !important;
              border-top: 1px solid rgba(0,0,0,0.08) !important;
              box-sizing: border-box !important;
            }

            .faqInner {
              max-width: 1080px !important;
              margin: 0 auto !important;
              padding: 70px 22px 96px !important;
              display: block !important;
              grid-template-columns: none !important;
              gap: 0 !important;
            }

            .faqHeader {
              max-width: 350px !important;
              margin-bottom: 38px !important;
            }

            .faqTitle {
              margin: 10px 0 0 !important;
              font-size: clamp(2.05rem, 8.6vw, 2.55rem) !important;
              line-height: 1.08 !important;
              letter-spacing: -0.015em !important;
              font-weight: 400 !important;
              text-transform: lowercase !important;
              color: #171717 !important;
            }

            .faqSub {
              max-width: 340px !important;
              margin: 14px 0 0 !important;
              font-size: 0.94rem !important;
              line-height: 1.52 !important;
              color: #555 !important;
              font-weight: 430 !important;
              letter-spacing: -0.012em !important;
            }

            .faqList {
              border-top: 1px solid rgba(0,0,0,0.08) !important;
            }

            .faqQuestion {
              min-height: auto !important;
              padding: 21px 0 !important;
              font-size: 1.02rem !important;
              line-height: 1.18 !important;
              letter-spacing: -0.022em !important;
              font-weight: 620 !important;
              text-transform: none !important;
            }

            .faqAnswer {
              max-width: 310px !important;
              margin: -4px 0 21px !important;
              font-size: 0.92rem !important;
              line-height: 1.5 !important;
              color: #555 !important;
              font-weight: 430 !important;
              letter-spacing: -0.01em !important;
            }

            .faqChevron {
              font-size: 1.02rem !important;
            }
          }
        `}
      </style>

      <div className="faqInner" style={styles.faqInner}>
        <div className="faqHeader" style={styles.faqHeader}>
          <p style={styles.sectionEyebrow}>FAQ</p>
          <h2 className="faqTitle" style={styles.faqTitle}>
            questions before you show up?
          </h2>
        </div>

        <div className="faqList" style={styles.faqList}>
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <div key={item.question} style={styles.faqItem}>
                <button
                  type="button"
                  className="faqQuestion"
                  style={styles.faqQuestion}
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                >
                  <span>{item.question}</span>
                  <IoChevronDown
                    className="faqChevron"
                    style={{
                      ...styles.chevron,
                      transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                  />
                </button>

                <div
                  style={{
                    ...styles.answerWrap,
                    maxHeight: isOpen ? "220px" : "0px",
                    opacity: isOpen ? 1 : 0,
                  }}
                >
                  <p className="faqAnswer" style={styles.faqAnswer}>
                    {item.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

const styles = {
  faqSection: {
    fontFamily:
      "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    background: "#fff",
    color: "#171717",
    borderTop: "1px solid rgba(17,17,17,0.08)",
  },
  faqInner: {
    maxWidth: 1180,
    margin: "0 auto",
    padding: "90px 28px 96px",
    boxSizing: "border-box",
    display: "grid",
    gridTemplateColumns: "0.85fr 1.15fr",
    gap: 60,
  },
  faqHeader: {
    maxWidth: 460,
    marginBottom: 0,
  },
  sectionEyebrow: {
    margin: 0,
    fontFamily: '"Ugly Handwriting", cursive',
    color: "#343c54",
    fontSize: "1.25rem",
    lineHeight: 1.15,
    fontWeight: 500,
    letterSpacing: "normal",
    textTransform: "lowercase",
  },
  faqTitle: {
    fontFamily: '"Instrument Serif", Georgia, serif',
    fontStyle: "normal",
    margin: "12px 0 0",
    color: "#171717",
    fontSize: "clamp(2rem, 3.7vw, 2.8rem)",
    lineHeight: 1.08,
    fontWeight: 400,
    letterSpacing: "-0.015em",
    textTransform: "none",
  },
  faqSub: {
    margin: "16px 0 0",
    maxWidth: 390,
    color: "#555",
    fontSize: "0.98rem",
    lineHeight: 1.52,
    fontWeight: 430,
    letterSpacing: "-0.012em",
  },
  faqList: {
    borderTop: "1px solid rgba(17,17,17,0.08)",
  },
  faqItem: {
    borderBottom: "1px solid rgba(17,17,17,0.08)",
  },
  faqQuestion: {
    width: "100%",
    minHeight: 64,
    border: "none",
    background: "transparent",
    padding: "21px 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 20,
    cursor: "pointer",
    textAlign: "left",
    color: "#171717",
    fontSize: "1.02rem",
    lineHeight: 1.18,
    letterSpacing: "-0.022em",
    fontWeight: 620,
    textTransform: "none",
    fontFamily: "inherit",
  },
  chevron: {
    flex: "0 0 auto",
    fontSize: 17,
    transition: "transform 180ms ease",
    color: "rgba(23,23,23,0.42)",
  },
  answerWrap: {
    overflow: "hidden",
    transition: "max-height 220ms ease, opacity 180ms ease",
  },
  faqAnswer: {
    maxWidth: 620,
    margin: "-4px 0 21px",
    fontSize: "0.92rem",
    lineHeight: 1.5,
    color: "#555",
    fontWeight: 430,
    letterSpacing: "-0.01em",
  },
};
